const FeatureKeys = {
  ENVELOPE_SEND_EMAIL: "envelope.send_email",
  ENVELOPE_BULK_SEND: "envelope.bulk_send",
  ENVELOPE_RENEWAL_NOTIFICATIONS: "envelope.renewal_notifications",
  TEMPLATE_USE: "template.use",
  TEMPLATE_FOLDERS: "template.folders",
  CONTACT_CSV_IMPORT: "contact.csv_import",
  COMPLIANCE_AUDIT_TRAIL: "compliance.audit_trail",
  AI_ASSISTANT: "ai.assistant",
  REPORTING_ANALYTICS: "reporting.analytics",
  TEAM_USAGE_REPORTS: "team.usage_reports",
  BRANDING_CUSTOM: "branding.custom",
  TEAM_ROLES: "team.roles",
  WORKSPACES: "workspaces",

  ENVELOPE_SELF_SIGN: "envelope.self_sign",
  ENVELOPE_MULTI_DOCUMENT: "envelope.multi_document",
  ENVELOPE_IN_PERSON: "envelope.in_person",
  ENVELOPE_SEND_SMS: "envelope.send_sms",
  ENVELOPE_SIGNING_ORDER: "envelope.signing_order",
  ENVELOPE_READ_RECEIPTS: "envelope.read_receipts",
  ENVELOPE_SCHEDULED_SEND: "envelope.scheduled_send",
  ENVELOPE_DELAYED_ROUTING: "envelope.delayed_routing",
  ENVELOPE_CONDITIONAL_ROUTING: "envelope.conditional_routing",
  ENVELOPE_AUTO_EXPIRATION: "envelope.auto_expiration",
  ENVELOPE_WEB_FORMS: "envelope.web_forms",
  TEMPLATE_APPROVAL_WORKFLOWS: "template.approval_workflows",

  AUTH_PASSCODE: "auth.passcode",
  AUTH_OTP: "auth.otp",
  AUTH_PHONE: "auth.phone",
  // Signer identity verification (photo ID + selfie / knowledge questions).
  // Hidden (not shown locked) unless enabled: ops switch it on per account.
  AUTH_IDENTITY_VERIFICATION: "auth.identity_verification",
  ENVELOPE_DELEGATION: "envelope.delegation",
  ENVELOPE_ADVANCED_FILTERS: "envelope.advanced_filters",

  REMINDER_AUTOMATIC: "reminder.automatic",
  REMINDER_MANUAL: "reminder.manual",

  API_ACCESS: "api.access",
} as const;

export type FeatureKey = (typeof FeatureKeys)[keyof typeof FeatureKeys];

export default FeatureKeys;
